
<div style="padding-right: 75px;">
    <div class="mt-1 app-left-margin w-100"  >
        <v-app-bar color="white" elevation="0"  height="45" style="padding-right: 75px">
            <v-app-bar-nav-icon
                @click="drawer=true"
                class="primary--text"
                style="margin-top: -2px"
            />
            <v-toolbar-title class="primary--text">EINSTELLUNGEN</v-toolbar-title>
            <v-spacer/>

            <div class="float-right" style="display: flex">
                <nav-user-menu />
            </div>
        </v-app-bar>

        <v-navigation-drawer
            v-model="drawer"
            absolute
            temporary
        >
            <c-app-side-drawer
                @close="onCloseSide ()"
            />
        </v-navigation-drawer>
    </div>

    <div class="v-flex app-left-margin">
        <v-tabs
            v-model="tab"
            class="mt-0 folder-tabs ml-0 mr-0 pr-0"
            active-class="folder-tab-active primary"
            show-arrows
            height="40"
        >
            <v-tabs-slider color="primary"></v-tabs-slider>
            <v-tab
                class="folder-tab"
                :key="1"
            >
                Standardmails
            </v-tab>
            <v-tab
                class="folder-tab"
                :key="2"
            >
                Signaturen
            </v-tab>
            <v-tab
                class="folder-tab"
                :key="3"
            >
                Stempel
            </v-tab>

            <v-tabs-items v-model="tab">
                <v-tab-item :key="1">
                    <template-mails ref="tab" />
                </v-tab-item>

                <v-tab-item :key="2">
                    <template-signatures ref="tab"  />
                </v-tab-item>

                <v-tab-item :key="3">
                    <c-preferences-details-stamp />
                </v-tab-item>
            </v-tabs-items>
        </v-tabs>
    </div>
</div>
